// Buy-together offer on the product page (snippets/bundle-offer.liquid). The checkbox belongs to
// the main product form, so product-form.js adds the offered product with the same quantity.
// While ticked, the add to cart button names both products and their total.
if (!customElements.get('bundle-offer')) {
  customElements.define(
    'bundle-offer',
    class BundleOffer extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector('.bundle-offer__check');
        this.price = Number(this.dataset.price);
        this.available = true;
        this.checkbox.addEventListener('change', () => this.update());
        document.addEventListener('change', (event) => {
          if (event.target.matches?.(`input[name="quantity"][form="${this.dataset.formId}"]`)) this.update();
        });
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.sectionId) return;
          // The product form resets the button text before this runs
          this.price = event.data.variant?.price ?? this.price;
          this.available = Boolean(event.data.variant?.available);
          this.update();
        });
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      update() {
        const text = document
          .getElementById(this.dataset.formId)
          ?.closest('product-form')
          ?.querySelector('[type="submit"] > span');
        if (!text || !this.available) return;
        if (!this.checkbox.checked) {
          text.textContent = window.variantStrings.addToCart;
          return;
        }
        const quantity = Math.max(
          1,
          Number(document.querySelector(`input[name="quantity"][form="${this.dataset.formId}"]`)?.value) || 1
        );
        const total = (this.price + Number(this.dataset.offerPrice)) * quantity;
        text.textContent = this.dataset.addBoth.replace('[price]', this.formatMoney(total));
      }

      formatMoney(cents) {
        const format = (decimals, thousands, decimal) => {
          const [whole, fraction] = (cents / 100).toFixed(decimals).split('.');
          const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return fraction ? `${grouped}${decimal}${fraction}` : grouped;
        };
        return this.dataset.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (match, placeholder) => {
          switch (placeholder) {
            case 'amount_no_decimals':
              return format(0, ',', '.');
            case 'amount_with_comma_separator':
              return format(2, '.', ',');
            case 'amount_no_decimals_with_comma_separator':
              return format(0, '.', ',');
            default:
              return format(2, ',', '.');
          }
        });
      }
    }
  );
}
